import firmConstants from "./constants";
import call from "../../service/http";

export default {
  namespaced: true,
  state: {
    firms: [],
    existingFirm: null,
    loadingExisting: false,
    activationStep: 1,
    selectedFirmDetails: null,
    firmSubscriptions: [],
    firmLicenses: [],
    loadingDetails: false,
  },
  mutations: {
    SET_FIRMS: (state, payload) => {
      state.firms = payload;
    },
    SET_EXISTING_FIRM: (state, payload) => {
      state.existingFirm = payload;
    },
    SET_LOADING_EXISTING: (state, payload) => {
      state.loadingExisting = payload;
    },
    SET_ACTIVATION_STEP: (state, payload) => {
      state.activationStep = payload;
    },
    SET_SELECTED_FIRM_DETAILS: (state, payload) => {
      state.selectedFirmDetails = payload;
    },
    SET_FIRM_SUBSCRIPTIONS: (state, payload) => {
      state.firmSubscriptions = payload;
    },
    SET_FIRM_LICENSES: (state, payload) => {
      state.firmLicenses = payload;
    },
    SET_LOADING_DETAILS: (state, payload) => {
      state.loadingDetails = payload;
    },
  },
  getters: {
    firms: (state) => state.firms,
    existingFirm: (state) => state.existingFirm,
    loadingExisting: (state) => state.loadingExisting,
    activationStep: (state) => state.activationStep,
    selectedFirmDetails: (state) => state.selectedFirmDetails,
    firmSubscriptions: (state) => state.firmSubscriptions,
    firmLicenses: (state) => state.firmLicenses,
    loadingDetails: (state) => state.loadingDetails,
  },
  actions: {
    getFirmApplications: ({ commit }, params) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null, { root: true });
      call("get", firmConstants.applications, null, { params })
        .then((res) => {
          commit("SET_FIRMS", res.data.data.data);
          commit("SET_LOADING", false, { root: true });
          Event.$emit("toggle-firms-list-loading", false);
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("toggle-firms-list-loading", false);
          commit(
            "SET_ALERT",
            {
              status: "error",
              message: err.response?.data?.message || "Failed to fetch firms",
            },
            { root: true }
          );
        });
    },
    getFirmProfiles: ({ commit }, params) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null, { root: true });
      call("get", firmConstants.profiles, null, { params })
        .then((res) => {
          commit("SET_FIRMS", res.data.data.data);
          commit("SET_LOADING", false, { root: true });
          Event.$emit("toggle-firms-list-loading", false);
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("toggle-firms-list-loading", false);
          commit(
            "SET_ALERT",
            {
              status: "error",
              message: err.response?.data?.message || "Failed to fetch firms",
            },
            { root: true }
          );
        });
    },

    getFirmFullDetails: ({ commit }, profileID) => {
      commit("SET_LOADING_DETAILS", true);
      const details = call("get", firmConstants.firmDetails(profileID));
      const subs = call("get", firmConstants.firmSubscriptions(profileID));
      const licenses = call("get", firmConstants.firmLicenses(profileID));

      return Promise.all([details, subs, licenses])
        .then(([detailsRes, subsRes, licensesRes]) => {
          commit("SET_SELECTED_FIRM_DETAILS", detailsRes.data.data);
          commit("SET_FIRM_SUBSCRIPTIONS", subsRes.data.data);
          commit("SET_FIRM_LICENSES", licensesRes.data.data);
          commit("SET_LOADING_DETAILS", false);
        })
        .catch((err) => {
          commit("SET_LOADING_DETAILS", false);
          commit(
            "SET_ALERT",
            {
              status: "error",
              message:
                err.response?.data?.message || "Failed to fetch firm details",
            },
            { root: true }
          );
        });
    },

    findExistingFirm: ({ commit }, firmNo) => {
      commit("SET_LOADING_EXISTING", true);
      commit("SET_ALERT", null, { root: true });
      return call("get", `${firmConstants.findExisting}/${firmNo}`)
        .then((res) => {
          commit("SET_EXISTING_FIRM", res.data.data);
          commit("SET_LOADING_EXISTING", false);
          commit("SET_ACTIVATION_STEP", 2);
          return res.data.data;
        })
        .catch((err) => {
          commit("SET_LOADING_EXISTING", false);
          commit(
            "SET_ALERT",
            {
              status: "error",
              message:
                err.response?.data?.message || "Firm not found in our records",
            },
            { root: true }
          );
          throw err;
        });
    },

    initiateActivation: ({ commit }, payload) => {
      commit("SET_LOADING", true, { root: true });
      return call("post", firmConstants.initiateActivation, payload)
        .then((res) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ACTIVATION_STEP", 3);
          return res.data.data;
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message:
                err.response?.data?.message || "Failed to initiate activation",
            },
            { root: true }
          );
          throw err;
        });
    },

    verifyActivation: ({ commit, dispatch }, payload) => {
      commit("SET_LOADING", true, { root: true });
      return call("post", firmConstants.verifyActivation, payload)
        .then((res) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_EXISTING_FIRM", null);
          commit("SET_ACTIVATION_STEP", 1);
          dispatch("getFirms");
          return res.data.data;
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message:
                err.response?.data?.message ||
                "Activation failed. Please check your OTP",
            },
            { root: true }
          );
          throw err;
        });
    },
  },
};
